export default "__VITE_ASSET__B2mj4TrR__"